import { CLOSE_OBJECTIVE_PROMPT_MODAL, OPEN_OBJECTIVE_PROMPT_MODAL } from 'actions/actionTypes';

export const openObjectivePromptModal = ({ contentComponent, wide = false }) => ({
  type: OPEN_OBJECTIVE_PROMPT_MODAL,
  payload: {
    contentComponent,
    isOpen: true,
    wide,
  },
});

export const closeObjectivePromptModal = () => ({
  type: CLOSE_OBJECTIVE_PROMPT_MODAL,
});
